import { SearchableRecordInstantSearch } from '@livv/models';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { Highlight } from 'react-instantsearch';
import { AttributeType } from '@utils/types/search';

const contentSx: SxProps = {
    color: 'grey.300',
    fontSize: 12,
};

export interface SecondaryAttributeData {
    attribute: string;
    attributeType?: AttributeType;
    conditionalDisplay?: 'always' | 'onHighlight';
    label?: string;
}

interface SecondaryAttributeProps extends Omit<SecondaryAttributeData, 'conditionalDisplay'> {
    hit: SearchableRecordInstantSearch;
}

const displayAttribute = (hit: SearchableRecordInstantSearch, attribute: string): boolean =>
    (hit[attribute] as unknown[])?.length > 0;

const SecondaryAttribute: FC<SecondaryAttributeProps> = ({
    attribute,
    attributeType,
    hit,
    label,
}) => {
    if (!displayAttribute(hit, attribute)) return null;

    const formattedLabel = label ? `${label} : ` : '';

    switch (attributeType) {
        case AttributeType.HIGHLIGHT:
            return (
                <Typography sx={contentSx} variant="body2">
                    {formattedLabel}
                    <Highlight attribute={attribute} hit={hit} />
                </Typography>
            );
        case AttributeType.PATH:
            return (
                <Typography component="div" sx={contentSx} variant="body2">
                    {formattedLabel}
                    <Typography display="inline" sx={contentSx} variant="body2">
                        <Highlight
                            attribute={attribute}
                            hit={hit}
                            separator={<ChevronRightIcon fontSize="inherit" sx={{ mb: -0.25 }} />}
                        />
                    </Typography>
                </Typography>
            );
        default:
            return (
                <Typography sx={contentSx} variant="body2">
                    <>
                        {formattedLabel}
                        {hit[attribute]}
                    </>
                </Typography>
            );
    }
};

export default SecondaryAttribute;
